module.exports = __webpack_public_path__ + "img/pro_img02.4353f6a5.png";